import React from "react";
import "aos/dist/aos.css"; // Import AOS styles
import AOS from "aos"; // Import AOS
import { useEffect } from "react";
import "../Styles/About.css";
import ChatBot from "./ChatBot";

function About() {
  useEffect(() => {
    AOS.init({ duration: 2000 }); // Initialize AOS with custom duration
  }, []);

  return (
    <div className="about-container">
      <div className="about-section" data-aos="fade-up">
        <h1 className="about-title" style={{ color: "white" }}>
          About Us
        </h1>
        <p className="about-description" style={{ color: "white" }}>
          Welcome to FusionXe Software Company, a leading software company
          specializing in creating custom software, websites, eCommerce
          platforms, and mobile applications. Our dedicated team of experts is
          committed to delivering innovative solutions tailored to meet your
          unique needs.
        </p>
      </div>

      <div className="about-section" data-aos="fade-up">
        <h2 className="about-subtitle">Our Services</h2>
        <div className="about-boxes">
          <div className="about-box" data-aos="fade-right">
            <h3>Custom Software</h3>
            <p>
              We develop custom software solutions that enhance your business
              operations and drive growth.
            </p>
          </div>
          <div className="about-box" data-aos="fade-left">
            <h3>Custom Websites</h3>
            <p>
              Our team designs and builds stunning websites that provide an
              exceptional user experience.
            </p>
          </div>
          <div className="about-box" data-aos="fade-right">
            <h3>eCommerce Websites</h3>
            <p>
              We create robust eCommerce platforms that help you sell your
              products and services online effectively.
            </p>
          </div>
          <div className="about-box" data-aos="fade-left">
            <h3>Mobile Applications</h3>
            <p>
              From concept to launch, we develop mobile apps that engage users
              and drive business success.
            </p>
          </div>
        </div>
      </div>

      <div className="about-section" data-aos="fade-up">
        <h2 className="about-subtitle">Our Products</h2>
        <div className="about-boxes">
          <div className="about-box" data-aos="fade-right">
            <h3>Kids Edu</h3>
            <p>
              An educational mobile app with videos tailored for children of
              different ages, designed to make learning fun and engaging.
            </p>
          </div>
          <div className="about-box" data-aos="fade-left">
            <h3>School Management App</h3>
            <p>
              A comprehensive mobile application with panels for students,
              parents, and teachers, integrated with AI to guide students’
              career paths.
            </p>
          </div>
          <div className="about-box" data-aos="fade-right">
            <h3>Social Media Platform</h3>
            <p>
              Our unique social media platform connects people and fosters
              community engagement through innovative features.
            </p>
          </div>
        </div>
      </div>

      <div className="about-section" data-aos="fade-up">
        <h2 className="about-subtitle" style={{ color: "white" }}>
          Our Mission
        </h2>
        <p className="about-description" style={{ color: "white" }}>
          At FusionXe, our mission is to empower businesses and individuals
          through cutting-edge technology solutions that drive success and
          innovation. We strive to deliver products and services that exceed our
          clients’ expectations and make a positive impact on their lives.
        </p>
      </div>

      <div className="about-section" data-aos="fade-up">
        <h2 className="about-subtitle" style={{ color: "white" }}>
          Contact Us
        </h2>
        <p className="about-description" style={{ color: "white" }}>
          Ready to take your business to the next level? Contact us today to
          learn more about our services and how we can help you achieve your
          goals.
        </p>
      </div>
      <ChatBot />
    </div>
  );
}

export default About;
